// NOTE: we currently don't support different color themes, so having a static config for colors would technically be enough
// However, by making this into a hook shape we can make the code more future proof and easily replace it with a real theme provider and hook
// in case we want to support theming in the future

export function useTheme() {
  return {
    primary: '#626AFF',
    error: '#FF6D69',
    green: '#23DDB2',
    neutral: {
      200: '#C6C8DC',
      300: '#A4A7C1',
      400: '#465480',
      // In some designs this is #2F3A5B
      // I assume this is a mistake and should actually be the same color
      500: '#2F3A5C',
      600: '#1E2741',
      700: '#192037',
      800: '#151B31',
      900: '#121729',
    },
  };
}
